import {
  createPlugin,
  createApiFactory,
  fetchApiRef,
  discoveryApiRef,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { GenAIBackendClient } from './api/GenAIBackendClient';
import { GenAIBackendAPIiRef } from './types';

export const genaiPlatformFrontendPlugin = createPlugin({
  id: 'genai-platform-frontend',
    apis: [
    createApiFactory({
      api: GenAIBackendAPIiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi}) =>
        new GenAIBackendClient( { discoveryApi, fetchApi } ),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const GenaiPlatformFrontendPage = genaiPlatformFrontendPlugin.provide(
  createRoutableExtension({
    name: 'GenAIPlatformFrontendPage',
    component: () =>
      import('./components/GenAIGatewayComponent').then(m => m.GenAIGatewayComponent),
   mountPoint: rootRouteRef,
  }),
);
